import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
const MagicLink = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Token não encontrado. Verifique o link recebido por email.');
        return;
      }
      try {
        const response = await authService.verifyMagicLink(token);
        setStatus('success');
        setMessage(response.message || 'Login realizado com sucesso!');
        // Redirect to home after a delay
        setTimeout(() => {
          navigate('/');
          // Dispatch storage event to update authentication state
          window.dispatchEvent(new Event('storage'));
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao verificar link. O token pode ser inválido ou ter expirado.');
      }
    };
    verifyToken();
  }, [token, navigate]);
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-1299">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md" data-id="element-1300">
        <h1 className="text-2xl font-bold text-center mb-6" data-id="element-1301">
          Login com Magic Link
        </h1>
        <div className="flex flex-col items-center justify-center space-y-4" data-id="element-1302">
          {status === 'loading' && <>
              <Loader2 size={48} className="text-[#1649ff] animate-spin" data-id="element-1303" />
              <p className="text-gray-600 text-center" data-id="element-1304">
                Verificando seu link de acesso...
              </p>
            </>}
          {status === 'success' && <>
              <CheckCircle size={48} className="text-green-500" data-id="element-1305" />
              <p className="text-green-600 text-center font-medium" data-id="element-1306">
                {message}
              </p>
              <p className="text-gray-500 text-center" data-id="element-1307">
                Você será redirecionado automaticamente em alguns segundos...
              </p>
            </>}
          {status === 'error' && <>
              <AlertCircle size={48} className="text-red-500" data-id="element-1308" />
              <p className="text-red-600 text-center font-medium" data-id="element-1309">{message}</p>
              <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1310">
                Voltar para a página inicial
              </button>
            </>}
        </div>
      </div>
    </div>;
};
export default MagicLink;